import { useState, useEffect } from 'react'
import { useQuery } from '@hooks/graphql'
import { gql } from 'graphql-request'

import JoinOrganization from './JoinOrganization'
import CreateOrganization from './CreateOrganization'
import BasicLayout from '@/components/Onboarding/Layout/BasicLayout'
import Spinner from '@/components/Spinner'
import { useFlashMessage } from '@/components/FlashMessage'

const SUGGESTED_ORGANIZATIONS_QUERY = gql`
  query suggestedOrganizations {
    suggestedOrganizations {
      id
      name
      membershipsCount
    }
  }
`

const JoinOrCreateOrganization = ({ nextStep, hasExistingMembership }) => {
  useEffect(() => {
    if (hasExistingMembership) nextStep()
  }, [hasExistingMembership, nextStep])


  const [decision, setDecision] = useState(null)
  const switchToCreate = () => setDecision('create')

  const { setFlashMessage } = useFlashMessage()

  const { data, isLoading } = useQuery({
    gqlQuery: SUGGESTED_ORGANIZATIONS_QUERY,
    queryKey: ["suggestedOrganizations"],
    onSuccess: (data) => {
      const { suggestedOrganizations } = data
      if (suggestedOrganizations.length > 0) {
        setDecision('join')
      } else {
        setDecision('create')
      }
    },
    onError: () => {
      setFlashMessage('Something went wrong', 'error')
    }
  })

  const organizations = data?.suggestedOrganizations ?? []

  return (
    <Choose>
      <When condition={isLoading}>
        <BasicLayout>
          <Spinner className='flex justify-center' />
        </BasicLayout>
      </When>
      <When condition={decision === 'join'}>
        <JoinOrganization
          organizations={organizations}
          switchToCreate={switchToCreate}
          nextStep={nextStep}
          />
      </When>
      <When condition={decision === 'create'}>
        <CreateOrganization
          nextStep={nextStep}
          />
      </When>
    </Choose>
  )
}

export default JoinOrCreateOrganization
